import Vue     from 'vue';
import Vuex    from 'vuex';
import getters from './getters';
import users   from './modules/users';
import common  from './modules/common';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    users
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js